<template>
  <div class="answer" :style="{ height: height + 'px' }">
    <div :style="{ height: ( height - 20 ) + 'px' }" class="content">
      <div class="rolling">
        <div @click="answer()" class="back">
          <img src="./back.png" width="25" height="25" alt="">返回
        </div>
        <div class="quwetion">七月的提问：上课效果怎么样？<span>(共4个回答)</span></div>
        <div class="ul">
          <li>
            <h5>英语课程一共有多少个章节？</h5>
            <p>
              <span>樱桃小丸子</span>
              发布于3分钟前
            </p>
          </li>
          <li>
            <h5>英语课程一共有多少个章节？</h5>
            <p>
              <span>樱桃小丸子</span>
              发布于3分钟前
            </p>
          </li>
          <li>
            <h5>英语课程一共有多少个章节？</h5>
            <p>
              <span>樱桃小丸子</span>
              发布于3分钟前
            </p>
          </li>
          <li>
            <h5>英语课程一共有多少个章节？</h5>
            <p>
              <span>樱桃小丸子</span>
              发布于3分钟前
            </p>
          </li>
        </div>
      </div>
      <el-input
        type="textarea"
        class="textarea"
        placeholder="请输入内容"
        v-model="textarea">
      </el-input>
      <div class="sure fr">保存笔记</div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      height: {
        type: Number,
        default: 3.5
      }
    },
    data () {
      return {
        textarea: ''
      }
    },
    methods: {
      answer () {
        this.$emit('changIndex', 1)
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .answer {
    width: 360px;
    margin: 0 auto;
    overflow: hidden;

    .content {
      margin: 20px auto 0;

      .textarea {
        height: 20%;
        margin-top: 10%;

        textarea {
          height: 100%;

          &:focus {
            border: 1px solid #ff827b;
          }
        }
      }

      .rolling {
        height: 60%;
        overflow-x: hidden;
        overflow-y: scroll;

        &::-webkit-scrollbar {
          display: none;
        }

        .back {
          cursor: pointer;
          height: 25px;
          line-height: 25px;
          color: #b3b3b3;
          font-size: 16px;

          img {
            display: block;
            float: left;
            margin: 0 5px 0 0;
          }
        }

        .quwetion {
          height: 25px;
          line-height: 25px;
          margin: 20px 0 0 0;
          font-size: 16px;

          span {
            color: #797979;
          }
        }

        .ul {
          li {
            padding: 20px 0;
            border-bottom: 1px solid #ebebeb;

            h5 {
              font-size: 14px;
              color: #636363;

              &:hover {
                text-decoration: underline;
              }
            }

            p {
              color: #919191;
              margin-top: 10px;

              span {
                font-size: 14px;

                &:last-child {
                  color: #919191;
                }
              }
            }
          }
        }

      }

      .sure {
        width: 110px;
        height: 40px;
        background-color: #ff8484;
        text-align: center;
        color: #fff;
        line-height: 40px;
        border-radius: 20px;
        cursor: pointer;
        margin: 20px 0 0 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/liveLayer/answer/answer.vue